import { render, staticRenderFns } from "./ThermalChart.vue?vue&type=template&id=16c2d270&scoped=true&"
import script from "./ThermalChart.vue?vue&type=script&lang=ts&"
export * from "./ThermalChart.vue?vue&type=script&lang=ts&"
import style0 from "./ThermalChart.vue?vue&type=style&index=0&id=16c2d270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2d270",
  null
  
)

export default component.exports